import React from 'react';
import SharedNavbarTop from 'shared_items/NavbarTop';

// Wrapper de compatibilidade — preserva a assinatura original (navegação só-ida pra settings).
// Implementação real em shared_items/NavbarTop.jsx (design-system fase 2/3). Remover em fase 4.
const NavbarTop = ({ title, onHomeClick, onLogoutClick, handleTabChange }) => (
  <SharedNavbarTop
    title={title}
    moduleKey="travel"
    onHomeClick={onHomeClick}
    settingsActive={false}
    onSettingsClick={() => handleTabChange('settings')}
    zIndexClass="z-20"
  />
);

export default NavbarTop;
